import axios, { AxiosResponse } from "axios";
import EstadoEjecucion from "../models/estadoEjecucion.model";
import { General } from "./general";

export function EstadosEjecucionService(props?: any) {
    const getEstadosEjecucion = async (): Promise<AxiosResponse<EstadoEjecucion[]>> => {
        return axios.get<EstadoEjecucion[]>(`${General.API_URL}/GetEstadosEjecucion`);
    }
    return (
        {
            getEstadosEjecucion,
        }
    );
}
